import { DonationType } from "@/constants";
import { DonorListComponent } from "./DonorListComponent";

export function AlmsDonors() {

    return (
        <DonorListComponent
            type={DonationType.EVENT_ALM}
        />
    )
}